<template>
  <div>
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh">
      <van-empty
        v-if="questionList.length == 0&&topList.length == 0"
        description="暂无内容"
      />

      <div class="recommend-box" v-if="topList.length !== 0||questionList.length !== 0">
        <div
          class="recommend-item"
          v-for="(item,index) in topList"
          :key="item.data.messageid">
          <div class="recommend-userInfo">
            <div class="recommend-userAvatar">
              <img :src="item.data.headimg" alt="">
            </div>
            <div style="display: flex;
                  flex-direction: column;
                  justify-content: space-around;">
              <div style="display:flex;">
                <div class="recommend-user">{{item.data.name}}</div>
                <div
                  class="userFlag"
                  v-if="item.data.chatdevice==0"
                >官方</div>
                <div class="msgFlag">置顶</div>
              </div>
              <div class="recommend-time">{{item.data.createtime}}</div>
            </div>
          </div>
          <div class="recommend-content">{{item.data.message}}</div>
        </div>
        <div
          class="recommend-item"
          v-for="(item,index) in questionList"
          :key="index">
          <div class="recommend-userInfo">
            <div class="recommend-userAvatar">
              <img :src="item.data.headimg" alt="">
            </div>
            <div style="display: flex;
                  flex-direction: column;
                  justify-content: space-around;">
              <div style="display:flex;">
                <div class="recommend-user">{{item.data.name}}</div>
                <div
                  class="userFlag"
                  v-if="item.data.chatdevice==0"
                >官方</div>
              </div>
              <div class="recommend-time">{{item.data.createtime}}</div>
            </div>
          </div>
          <div class="recommend-content">{{item.data.message}}</div>
        </div>
      </div>
    </van-pull-refresh>
    <div class="send-box">
      <div class="send-img"><img
          :src="info.headimgurl"
          alt=""
        ></div>
      <div class="text-inp-btn">
        <van-field
          v-model="text"
          placeholder="请输入评论"
        />
      </div>
      <div class="send-btn" @click="sendMsg">
        发送
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/file";
import {
  mapState,
  mapMutations
} from "vuex";
import { Toast } from 'vant';
import { opneLoginPane, liveHasLogin, getWxPay } from "@/utils/app";
export default {
  data () {
    return {
      text: '',
      questionList: [], // 消息
      topList:[], // 置顶信息
      tipsList:[], // 提示
      giftList:[], // 礼物
      loading: false,
      refreshing: false,
      info: {
        origin: 'web',
        nickname:'游客',
        id:'游客'+Math.round(Math.random()*1000),
        headimgurl: require('@/assets/img/default-header.png'),
      },
    };
  },
  props: {
    userinfo: {
      default: () => {
        return {};
      },
      required: true,
    },
    tvId: {
      default: "",
      required: true,
    },
  },
  created () {
    console.log(JSON.stringify(this.userinfo)!=="{}",'评论');
    if (JSON.stringify(this.userinfo)!=="{}") {
      this.info = this.userinfo
    }
    this.activityId=this.$route.query.id
    this.onLoad()
  },
  computed: {
    ...mapState(["config", "inWX", "giftbtn", "IOS","Android"]),
    getWsMsg() {
      //在核心代码接收到的服务端信息存储到vuex的属性
        return this.$store.state.webSocketMsg
    }
  },
  destroyed () {
    console.log('离开');
    if(this.$setWs.ws){
      this.$setWs.ws.close() // 离开当前页面销毁socket
    }
  },
  watch: {
    userinfo(newData){
      this.info = newData
    },
    getWsMsg(data, val) {
      if (data!=='{}') {
        this.messageData = JSON.parse(data)
        this.questionList=this.messageData.questionList
        this.topList=this.messageData.topList
        this.giftList=this.messageData.giftList
        this.tipsList=this.messageData.tipsList
      }
    }
  },
  methods: {
    // 请求全部信息
    getDetall(type) {
      var a = {
          seq:this.uuid,
          type:type,
          data:{
            type: "getall",
            liveId: this.activityId,
            pagesize:10,
            offset:0,
          }
        };
      this.$setWs.ws.send(JSON.stringify(a));
    },
    socketOpen (type,websocketId,userinfo) {
      if (JSON.stringify(this.userinfo)!=="{}") {
        var origin=userinfo.origin
        var userName=userinfo.nickname
      } else{
        var origin=this.inWX?'wechat':(this.IOS||this.Android)?'app':'web'
        var userName=this.info.nickname
      }
      var device = 1
      let wsServer=''
      console.log(process.env.NODE_ENV);
      if (process.env.NODE_ENV == 'production') {
        var num = process.env.VUE_APP_SCOKET.indexOf('https://')
        var protocol = process.env.VUE_APP_SCOKET.indexOf('https')!==-1 ? 'wss' : 'ws'
        var str = process.env.VUE_APP_SCOKET.substr(num+8)
        wsServer = `${protocol}://${str}websocket/${type}-${websocketId}-${origin}-${userName}-${device}`
      } else {
        wsServer = `${location.protocol === 'http:' ? 'ws' : 'wss'}://${location.host}/websocket/${type}-${websocketId}-${origin}-${userName}-${device}`
      }
      console.log(wsServer);
      this.$setWs.initWebSocket(wsServer) // 调用全局定义socket,传入链接
      setTimeout(() => {
        axios.get(this.$api.getUuidSer).then(({ data }) => {
              if (data.status == 0) {
                this.uuid = data.data;
                this.getDetall(type)
              }
            })
      }, 500);
    },
    // 发送消息
    sendMsg() {
      if(JSON.stringify(this.userinfo)!=='{}'){
          if (this.text == "") {
            this.$toast.fail("请输入内容");
          } else {
            this.sendMsgobj={}
            axios.get(this.$api.getUuidSer).then(({ data }) => {
              if (data.status == 0) {
                this.uuid = data.data;
                this.sendMsgobj={
                seq:this.uuid,
                type:"chat",
                chatType:this.$route.query.tvType,
                data:{
                  messagetype:'send',
                  type:'send',
                  userid:this.info.id,
                  name:this.info.nickname,
                  headimg:this.info.headimgurl,
                  origin:this.info.origin,
                  liveId:this.activityId,
                  message:this.text,
                  word:this.text
                  }
                }
                this.$setWs.ws.send(JSON.stringify(this.sendMsgobj));
                this.text = ""
              }
            })
          }
        }else{
          this.$dialog
            .confirm({
              title: "提示",
              message: "该操作需要登录后进行,是否确认登录？",
            })
            .then(() => {
              if (this.inWX) {
                this.$router.replace({name:"login",query: {id:this.$route.query.id,tvType: this.$route.query.tvType}});
              } else if (this.IOS||this.Android) {
                opneLoginPane()
                window.localStorage.clear();
              }else {
                this.$toast('网页暂不支持此功能!')
              }
            })
            .catch(() => {});
        };
    },
    onLoad () {
      // setTimeout(() => {
      //   if (this.refreshing) {
      //     this.questionList = [];
      //     this.refreshing = false;
      //   }
      //   for (let i = 0; i < 10; i++) {
      //     let item = {
      //       content: '花瓣网, 设计师寻找灵感的天堂!图片素材领导者,帮你采集、发现网络上你喜欢的事物。你可以用它收集灵感,保存有用的素材,计划旅行,晒晒自己想要的东西',
      //       user: '贾露阳',
      //       time: '2021-10-15 12:00:00',
      //       img: 'https://t7.baidu.com/it/u=852388090,130270862&fm=193&f=GIF',
      //       userFlag: i == 0 ? '1' : '0',
      //       msgFlag: i % 2 == 0 ? '1' : '0',
      //     }
      //     this.questionList.push(item);
      //   }
      //   this.loading = false;
      // }, 500);
    },
    onRefresh () {
      this.refreshing = true
      this.onLoad()
      setTimeout(() => {
        Toast('刷新成功');
        this.refreshing = false;
      }, 1000);
    }
  },
}
</script>

<style scoped>
.recommend-box {
  padding: 0 16px;
  box-sizing: border-box;
  width: 100%;
  padding-bottom: 90px;
  /* height: calc(100vh -254px -80px); */
  /* overflow-y: scroll;
  overflow-x: hidden; */
}
.recommend-item {
  width: 100%;
  padding: 12px 0;
  border-bottom: 1px solid #eeeeee;
}
.recommend-item .recommend-userInfo {
  display: flex;
  height: 38px;
}
.recommend-item .recommend-userInfo .recommend-userAvatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 7px;
}
.recommend-item .recommend-userInfo .recommend-userAvatar img {
  width: 34px;
  height: 34px;
}
.recommend-user {
  color: #333333;
  font-size: 14px;
  font-weight: 700;
}
.userFlag {
  background: #f55151;
  border-radius: 2px;
  color: #fff;
  font-size: 9px;
  font-weight: Regular;
  padding: 2px 6px;
  margin-left: 6px;
  display: inline;
}
.msgFlag {
  background: #F0963A;
  border-radius: 2px;
  color: #fff;
  font-size: 9px;
  font-weight: Regular;
  padding: 2px 6px;
  margin-left: 6px;
  display: inline;
}
.recommend-time {
  color: #999;
  font-size: 10px;
}
.recommend-content {
  font-size: 14px;
  color: #333333;
  padding-left: 41px;
  margin-top: 7px;
}
.send-box {
  display: flex;
  padding: 10px 15px;
  align-items: center;
  box-shadow: 0px -9px 11px rgba(207, 207, 207, 0.17);
  justify-content: space-around;
  position: fixed;
  bottom: 0px;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
}
.send-img {
  width: 34px;
  height: 34px;
  overflow: hidden;
  border-radius: 50%;
}
.send-img > img {
  width: 34px;
  height: 34px;
}
.send-btn {
  border-radius: 15px;
  width: 62px;
  height: 30px;
  background: #be1928;
  text-align: center;
  line-height: 30px;
  font-size: 16px;
  color: #fff;
}
.van-cell {
  background: #fff;
  border: 1px solid #b1b1b1;
  border-radius: 30px;
  padding: 4px 10px;
}
.text-inp-btn{
  width: 66%;
}
</style>
<style>
input::-webkit-input-placeholder {
  color: #b1b1b1 !important;
}
</style>